(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbPanelDetailsDataStore', ['$mdMedia',PanelDetailsDataStore]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbPanelDetailsDataStore
	 *
	 * @description
	 * Manages the state of the application's side panel.
	 */
	function PanelDetailsDataStore($mdMedia) {
		var _isOpen = false;
		var _isOpenInline = false;

		return {
			/**
			 * @ngdoc property
			 * @name smbPanelDetailsDataStore#isOpen
			 * @propertyOf smb-app.smbPanelDetailsDataStore
			 * @kind property
			 *
			 * @description
			 * Returns true if the side panel is currently open.
			 *
			 * @returns {boolean} A boolean flag that indicates whether the side panel is open (true)
			 * or closed (false).
			 */
			get isOpen() { return _isOpen; },

			/**
			 * @ngdoc property
			 * @name smbPanelDetailsDataStore#isOpen
			 * @propertyOf smb-app.smbPanelDetailsDataStore
			 * @kind property
			 *
			 * @description
			 * Use to open or close the side panel. Set to true to open the side panel
			 * and false to close the side panel.
			 *
			 * @param {boolean} val The value to set the property to.
			 */
			set isOpen(val) { _isOpen = val; },

			/**
			 * @ngdoc property
			 * @name smbPanelDetailsDataStore#isOpenInline
			 * @propertyOf smb-app.smbPanelDetailsDataStore
			 * @kind property
			 *
			 * @description
			 * Indicates if the side panel is open in inline mode.
			 *
			 * @returns {boolean} True if the panel is open inline
			 */
			get isOpenInline() { return _isOpenInline; },

			/**
			 * @ngdoc method
			 * @name smbPanelDetailsDataStore#toggle
			 * @methodOf smb-app.smbPanelDetailsDataStore
			 * @kind method
			 *
			 * @description
			 * Toggle the side panel. Opens it if it is currently closed and closes it if
			 * it is currently open.
			 */
			toggle: toggle,

			/**
			 * @ngdoc method
			 * @name smbPanelDetailsDataStore#reset
			 * @methodOf smb-app.smbPanelDetailsDataStore
			 * @kind method
			 *
			 * @description
			 * Resets the state of the side panel back to default (which is closed).
			 */
			reset: reset,

			/**
			 * @ngdoc method
			 * @name smbPanelDetailsDataStore#showPanel
			 * @methodOf smb-app.smbPanelDetailsDataStore
			 * @kind method
			 *
			 * @description
			 * Returns true if the panel should be open.
			 *
			 * @returns {boolean} True if the panel should be open.
			 */
			showPanel: showPanel
		};

		function toggle() {
			_isOpen = !_isOpen;
			if ($mdMedia('gt-sm')) {
				_isOpenInline = !_isOpenInline;
			}
		}

		function showPanel() {
			return _isOpen || _isOpenInline;
		}

		function reset() {
			_isOpen = false;
			_isOpenInline = false;
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/panelDetailsDataStore.js
// module id = 127
// module chunks = 1